// @flow
import React from 'react';
import { DateUtils } from 'react-day-picker';
import { noop } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { formatMonthTitle } from './Datepicker.utils';

type Props = {
  className?: string,
  fromMonth: Date,
  locale?: string,
  month?: Date,
  onNext: () => void,
  onPrevious: () => void,
  toMonth: Date,
  // https://react-day-picker.js.org/api/DayPicker#navbarElement
};

export function DatepickerArrow({
  className,
  fromMonth,
  locale,
  month,
  onPrevious = noop,
  onNext = noop,
  toMonth,
}: Props) {
  return (
    <div className={className}>
      {!DateUtils.isSameMonth(month, fromMonth) ? (
        <button
          className="reset-button"
          data-testid="datepicker-arrow-prev"
          onClick={() => onPrevious()}
          style={{ width: 30, height: 30 }}
          type="button"
        >
          <Icon
            color={COLORS.GRAY_DARKER}
            hasRtl
            name={ICONS.BOLDER_ARROW_FORTH}
            rotation={180}
            width="0.625rem"
          />
        </button>
      ) : (
        <div style={{ width: 30, height: 30 }} />
      )}
      <span className="flex-1">{formatMonthTitle(month, locale)}</span>
      {!DateUtils.isSameMonth(month, toMonth) ? (
        <button
          className="reset-button"
          data-testid="datepicker-arrow-next"
          onClick={() => onNext()}
          style={{ width: 30, height: 30 }}
          type="button"
        >
          <Icon
            color={COLORS.GRAY_DARKER}
            hasRtl
            name={ICONS.BOLDER_ARROW_FORTH}
            width="0.625rem"
          />
        </button>
      ) : (
        <div style={{ width: 30, height: 30 }} />
      )}
    </div>
  );
}
